import { render, staticRenderFns } from "./productmallaftersales.vue?vue&type=template&id=0a903c96&scoped=true"
import script from "./productmallaftersales.vue?vue&type=script&lang=js"
export * from "./productmallaftersales.vue?vue&type=script&lang=js"
import style0 from "./productmallaftersales.vue?vue&type=style&index=0&id=0a903c96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a903c96",
  null
  
)

component.options.__file = "productmallaftersales.vue"
export default component.exports